import React from "react";
import {
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font,
  Svg,
  Line,
  Polygon,
} from "@react-pdf/renderer";
// import IMAGES from "../../../constant/IMAGES";

// import regular from '../../../assets/fonts/Notosans/NotoSans_SemiCondensed-Regular.ttf';
// import semiBold from '../../../assets/fonts/Notosans/NotoSans_SemiCondensed-SemiBold.ttf';
// import bold from '../../../assets/fonts/Notosans/NotoSans_SemiCondensed-Bold.ttf';
// import italic from '../../../assets/fonts/Notosans/NotoSans_SemiCondensed-Italic.ttf';
// import boldItalic from '../../../assets/fonts/Notosans/NotoSans_SemiCondensed-BoldItalic.ttf';
// import extraBold from '../../../assets/fonts/Notosans/NotoSans_SemiCondensed-ExtraBold.ttf';

// import Bold from '../../../Font/BeVietnamPro/BeVietnamPro-Bold.ttf';
// import Italic from '../../../Font/BeVietnamPro/BeVietnamPro-Italic.ttf';
// import Regular from '../../../Font/BeVietnamPro/BeVietnamPro-Regular.ttf';
import Black from "../../../Font/Inter/Inter_18pt-Black.ttf";
import Bold from "../../../Font/Inter/Inter_18pt-Bold.ttf";
import SemiBold from "../../../Font/Inter/Inter_18pt-SemiBold.ttf";
import Italic from "../../../Font/Inter/Inter_18pt-Italic.ttf";
import Medium from "../../../Font/Inter/Inter_18pt-Medium.ttf";
import Regular from "../../../Font/Inter/Inter_18pt-Regular.ttf";

// import Bold from '../../../Font/Lexend/Lexend-Bold.ttf';
// import Medium from '../../../Font/Lexend/Lexend-Medium.ttf';
// import Regular from '../../../Font/Lexend/Lexend-Regular.ttf';

// import Bold from '../../../Font/Mulish/Mulish-Bold.ttf';
// import Italic from '../../../Font/Mulish/Mulish-Italic.ttf';
// import Regular from '../../../Font/Mulish/Mulish-Regular.ttf';

// import Black from '../../../Font/SourceSans3/SourceSans3-Black.ttf';
// import Bold from '../../../Font/SourceSans3/SourceSans3-Bold.ttf';
// import SemiBold from '../../../Font/SourceSans3/SourceSans3-SemiBold.ttf';
// import Italic from '../../../Font/SourceSans3/SourceSans3-Italic.ttf';
// import Medium from '../../../Font/SourceSans3/SourceSans3-Medium.ttf';
// import Regular from '../../../Font/SourceSans3/SourceSans3-Regular.ttf';

import {
  SAO_TOT,
  SAO_XAU,
  CONG_VIEC_MAPPING,
  NGAY_HOANGDAO_HACDAO_MAPPING,
  WEEKDAY_MAPPING,
  CAN_CHI,
  NGU_HANH,
  TIET_KHI,
  TRUC,
  TU,
  BACH_KY,
  ZODIAC_IMAGE_KEY_MAP,
} from "../../../constant/MAPPING";

import logoPT from "../../../assets/images/perpetual_calendars/logoPT.png";
import sunrise from "../../../assets/images/perpetual_calendars/sunrise.svg";
import sunlunch from "../../../assets/images/perpetual_calendars/sunlunch.svg";
import sunset from "../../../assets/images/perpetual_calendars/sunset.svg";
import ti from "../../../assets/images/perpetual_calendars/ti.png";
import suu from "../../../assets/images/perpetual_calendars/suu.png";
import dan from "../../../assets/images/perpetual_calendars/dan.png";
import mao from "../../../assets/images/perpetual_calendars/mao.png";
import thin from "../../../assets/images/perpetual_calendars/thin.png";
import ty from "../../../assets/images/perpetual_calendars/ty.png";
import ngo from "../../../assets/images/perpetual_calendars/ngo.png";
import mui from "../../../assets/images/perpetual_calendars/mui.png";
import than from "../../../assets/images/perpetual_calendars/than.png";
import dau from "../../../assets/images/perpetual_calendars/dau.png";
import tuat from "../../../assets/images/perpetual_calendars/tuat.png";
import hoi from "../../../assets/images/perpetual_calendars/hoi.png";
import shouddo from "../../../assets/images/perpetual_calendars/shoulddo.png";
import limit from "../../../assets/images/perpetual_calendars/limit.png";
import sunrisered from "../../../assets/images/perpetual_calendars/sunrisered.svg";
import sunlunchred from "../../../assets/images/perpetual_calendars/sunlunchred.svg";
import sunsetred from "../../../assets/images/perpetual_calendars/sunsetred.svg";
import sunriseblue from "../../../assets/images/perpetual_calendars/sunriseblue.svg";
import sunlunchblue from "../../../assets/images/perpetual_calendars/sunlunchblue.svg";
import sunsetblue from "../../../assets/images/perpetual_calendars/sunsetblue.svg";
import shoulddored from "../../../assets/images/perpetual_calendars/shoulddored.png";
import tired from "../../../assets/images/perpetual_calendars/tired.png";
import suured from "../../../assets/images/perpetual_calendars/suured.png";
import danred from "../../../assets/images/perpetual_calendars/danred.png";
import maored from "../../../assets/images/perpetual_calendars/maored.png";
import thinred from "../../../assets/images/perpetual_calendars/thinred.png";
import tyred from "../../../assets/images/perpetual_calendars/tyred.png";
import ngored from "../../../assets/images/perpetual_calendars/ngored.png";
import muired from "../../../assets/images/perpetual_calendars/muired.png";
import thanred from "../../../assets/images/perpetual_calendars/thanred.png";
import daured from "../../../assets/images/perpetual_calendars/daured.png";
import tuatred from "../../../assets/images/perpetual_calendars/tuatred.png";
import hoired from "../../../assets/images/perpetual_calendars/hoired.png";
import tiblue from "../../../assets/images/perpetual_calendars/tiblue.png";
import suublue from "../../../assets/images/perpetual_calendars/suublue.png";
import danblue from "../../../assets/images/perpetual_calendars/danblue.png";
import maoblue from "../../../assets/images/perpetual_calendars/maoblue.png";
import thinblue from "../../../assets/images/perpetual_calendars/thinblue.png";
import tyblue from "../../../assets/images/perpetual_calendars/tyblue.png";
import ngoblue from "../../../assets/images/perpetual_calendars/ngoblue.png";
import muiblue from "../../../assets/images/perpetual_calendars/muiblue.png";
import thanblue from "../../../assets/images/perpetual_calendars/thanblue.png";
import daublue from "../../../assets/images/perpetual_calendars/daublue.png";
import tuatblue from "../../../assets/images/perpetual_calendars/tuatblue.png";
import hoiblue from "../../../assets/images/perpetual_calendars/hoiblue.png";
import shoulddoblue from "../../../assets/images/perpetual_calendars/shoulddoblue.png";

const IMAGES = {
  logoPT,
  sunrise,
  sunlunch,
  sunrisered,
  sunlunchred,
  sunsetred,
  sunset,
  sunriseblue,
  sunlunchblue,
  sunsetblue,
  ti,
  suu,
  dan,
  mao,
  thin,
  ty,
  ngo,
  mui,
  than,
  dau,
  tuat,
  hoi,
  tired,
  suured,
  danred,
  maored,
  thinred,
  tyred,
  ngored,
  muired,
  thanred,
  daured,
  tuatred,
  hoired,
  tiblue,
  suublue,
  danblue,
  maoblue,
  thinblue,
  tyblue,
  ngoblue,
  muiblue,
  thanblue,
  daublue,
  tuatblue,
  hoiblue,
  shouddo,
  limit,
  shoulddored,
  shoulddoblue,
};

Font.register({
  family: "Inter",
  fonts: [
    { src: Black, fontWeight: 900 },
    { src: Bold, fontWeight: 700 },
    { src: SemiBold, fontWeight: 600 },
    { src: Italic, fontStyle: "italic" },
    { src: Medium, fontWeight: 500 },
    { src: Regular, fontWeight: 400 },
  ],
});
Font.registerHyphenationCallback((word) => [word]);
// ========================================================================
// COLORS
// ========================================================================
const COLOR_BORDER = "#c9b79c";
const COLOR_PRIMARY_TEXT = "#A98137";
const COLOR_INTRO = "#A62A26";
const COLOR_RED = "#C62627";
const COLOR_BLUE = "#1e3a8a";
const COLOR_GREEN = "#266914";
const COLOR_BORDER_DEFAULT = "#C1AC96";
const COLOR_BLACK = "#1A1A1A";

// ========================================================================
// HELPERS
function extractDMY(dateStr?: string) {
  if (!dateStr) return { day: "--", month: "--", year: "--" };

  // ISO: 2026-05-01 hoặc 2026-05-01T...
  const isoMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch)
    return { day: isoMatch[3], month: isoMatch[2], year: isoMatch[1] };

  // DD/MM/YYYY
  const dmyMatch = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (dmyMatch)
    return {
      day: dmyMatch[1].padStart(2, "0"),
      month: dmyMatch[2].padStart(2, "0"),
      year: dmyMatch[3],
    };

  // Fallback: try native Date parsing (may be unreliable for DD/MM/YYYY)
  const dt = new Date(dateStr);
  if (!isNaN(dt.getTime())) {
    return {
      day: String(dt.getDate()).padStart(2, "0"),
      month: String(dt.getMonth() + 1).padStart(2, "0"),
      year: String(dt.getFullYear()),
    };
  }

  // nếu không parse được, trả nguyên chuỗi vào day
  return { day: dateStr, month: "--", year: "--" };
}

const mapArrayWithObject = (
  arr: string[] | undefined,
  mapping: Record<string, string>,
) => {
  if (!Array.isArray(arr) || arr.length === 0) return "Không có";
  return arr.map((key) => mapping[key] || key).join(", ");
};

const mapSpecialBachKy = (
  bachKy: string[] | undefined,
  day: string,
  month: string,
  year: string,
) => {
  if (Number(day) === 26 && Number(month) === 6 && Number(year) === 2027)
    return <Text style={styles.bold}>{"Tam Nương, Thọ Tử, Nguyệt Phá"}</Text>;
  return bachKy?.map((d: any, idx: number) => (
    <Text key={idx} style={styles.bold}>
      {mapArrayWithObject([d], BACH_KY)}
      {idx < bachKy.length - 1 ? ", " : ""}
    </Text>
  ));
};

// Capitalize first letter, lowercase the rest (giống .toLowerCase().replace(/^./, s => s.toUpperCase()))
const capitalizeFirst = (str: string) => {
  if (!str) return str;
  const lower = str.toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};

// Lấy accent color theo logic gốc
const getAccentColor = (
  isEvenPage: boolean,
  isSunday: boolean,
  hasEvents: boolean,
) => {
  if (hasEvents || isSunday) return COLOR_RED;
  return isEvenPage ? COLOR_BLUE : COLOR_GREEN;
};

// Lấy màu border của box ngoài cùng theo logic gốc (boxClass)
const getBoxBorderColor = (
  isEvenPage: boolean,
  isSunday: boolean,
  hasEvents: boolean,
) => {
  const isRed = isSunday || hasEvents;
  if (isRed) return COLOR_BORDER_DEFAULT; // "#C1AC96"
  return isEvenPage ? COLOR_BLUE : COLOR_GREEN;
};

// ========================================================================
// STYLES
// ========================================================================
const MM_TO_PT = 2.834645669;
const A4_HEIGHT_PT = 297 * MM_TO_PT; // 841.89pt
const PAGE_PADDING_V = 20 * MM_TO_PT; // khớp với paddingTop/paddingBottom "20mm" ở style `page`
const CONTAINER_HEIGHT = A4_HEIGHT_PT - PAGE_PADDING_V * 2; // ≈ 728.5pt
const ACTION_ROW_HEIGHT = 50;

const styles = StyleSheet.create({
  page: {
    paddingTop: "15mm",
    paddingBottom: "2mm",
    paddingHorizontal: 20,
    letterSpacing: 0,
    wordSpacing: 1,
    fontSize: 11.4,
    fontFamily: "Inter",
    backgroundColor: "#FFFFFF",
    flexDirection: "column",
    height: "100%",
    lineHeight: 1.15,
  },

  // ---- Container / Background watermark ----
  container: {
    position: "relative",
    backgroundColor: "#FFFFFF",
    flexDirection: "column",
    flex: 1,
    height: CONTAINER_HEIGHT, // thay cho flex: 1
  },
  watermark: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-170pt, -170pt)",
    width: 340,
    opacity: 0.45,
  },

  // ---- Header ----
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 12,
    paddingTop: 8,
  },
  headerText: {
    fontSize: 11,
    fontWeight: 600,
    color: COLOR_INTRO,
    textTransform: "uppercase",
  },
  titleWrap: {
    paddingHorizontal: 16,
    paddingTop: 7,
    textAlign: "center",
  },
  title: {
    fontSize: 16,
    fontWeight: 900,
    color: COLOR_PRIMARY_TEXT,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    textAlign: "center",
  },

  // ---- Body ----
  bodyWrap: {
    paddingHorizontal: 12,
    paddingBottom: 0,
    flexDirection: "column",
    flex: 1,
  },

  // ---- Day box ----
  dayBox: {
    borderWidth: 1.5,
    borderRadius: 6,
    padding: 3.5,
    height: "48%",
    flexDirection: "column",
    position: "relative",
  },

  // top section: date card + info table
  topSection: {
    flexDirection: "row",
    alignItems: "stretch",
    height: "37%",
    flex: 1,
  },
  bottomSection: {
    height: "63%",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  // ---- Date card (left column) ----
  dateCardWrap: {
    width: "23%",
    minWidth: "23%",
    paddingHorizontal: 5,
    alignSelf: "stretch",
  },

  dateCardInner: {
    backgroundColor: "transparent",
    flex: 1,
    flexDirection: "column",
  },

  dateCardBody: {
    borderWidth: 1,
    borderBottomWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 1,
    borderTopWidth: 0,
    borderColor: COLOR_BORDER_DEFAULT,
    paddingHorizontal: 5,
    paddingBottom: 6,
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    flex: 1,
    justifyContent: "space-evenly",
  },

  dateCardHeader: {
    textAlign: "center",
    fontSize: 9,
    fontWeight: 900,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    color: "#FFFFFF",
    backgroundColor: "transparent",
    borderWidth: 1,
    paddingTop: 4,
  },

  // Border bottom
  cornerBottom: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 11,
    height: 1,
    backgroundColor: COLOR_BORDER_DEFAULT,
  },

  // Border right
  cornerRight: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 11,
    width: 1,
    backgroundColor: COLOR_BORDER_DEFAULT,
  },

  // Góc chéo
  cornerCut: {
    position: "absolute",
    bottom: 0,
    right: 0,
    width: 11.3,
    height: 11.3,
    backgroundColor: "transparent",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },

  cornerLine: {
    width: 16,
    height: 1,
    backgroundColor: COLOR_BORDER_DEFAULT,
    transform: "rotate(-45deg)",
  },
  solarDay: {
    fontSize: 40,
    fontWeight: 900,
    lineHeight: 1,
    marginTop: -5,
    marginBottom: 7,
    paddingTop: 0,
    textAlign: "center",
  },
  divider: {
    borderBottomWidth: 1,
    width: "100%",
    marginVertical: 0,
  },
  monthYear: {
    fontSize: 9,
    fontWeight: 700,
    textAlign: "center",
    marginTop: 2,
  },
  lunarDate: {
    fontSize: 10,
    color: COLOR_BLACK,
    fontWeight: 400,
    textAlign: "center",
    marginTop: 1,
  },
  eventText: {
    fontSize: 10,
    color: COLOR_RED,
    fontWeight: 500,
    textAlign: "center",
    marginTop: 2,
  },
  cellPadding: {
    paddingLeft: 4,
    paddingRight: 5,
    paddingVertical: 5,
  },
  // ---- Info table (right column) ----
  infoTable: {
    width: "80%",
    flexDirection: "column",
    flexGrow: 1,
  },
  infoRow2Col: {
    flexDirection: "row",
    flexGrow: 1,
  },
  infoCellHalf: {
    width: "50%",
    flexDirection: "row",
  },
  infoCellHalfPlain: {
    width: "50%",
    padding: 4,
  },
  borderTop: {
    borderTopWidth: 1,
    borderColor: COLOR_BORDER_DEFAULT,
  },
  borderBottom: {
    borderBottomWidth: 1,
    borderColor: COLOR_BORDER_DEFAULT,
  },
  borderRight: {
    borderRightWidth: 1,
    borderColor: COLOR_BORDER_DEFAULT,
  },
  bold: {
    fontWeight: 700,
  },
  tietCell: {
    width: "25%",
    padding: 4,
    borderRightWidth: 1,
    borderColor: COLOR_BORDER_DEFAULT,
    flexDirection: "row",
    gap: 4,
    alignItems: "flex-start",
  },
  tietCellInner: {
    flexDirection: "column",
  },

  // sun info row
  sunInfoCell: {
    flexDirection: "row",
    alignItems: "center",
  },
  sunIcon: {
    width: 23,
    height: 23,
  },
  sunInfoTextWrap: {
    flexDirection: "column",
    gap: 1,
    marginLeft: 4,
  },

  // ---- Generic Row / Cell (giống Row/Cell trong utils) ----
  row2Col: {
    flexDirection: "row",
    flexGrow: 1,
  },
  cell: {
    width: "50%",
    padding: 4,
    fontSize: 11.4,
    alignSelf: "stretch",
  },
  cellBorderRight: {
    borderRightWidth: 1,
    borderColor: COLOR_BORDER_DEFAULT,
  },
  cellFullWidth: {
    width: "100%",
    padding: 4,
    fontSize: 11.4,
  },

  // nested 2-col inside cell
  innerRow2Col: {
    flexDirection: "row",
  },
  innerCellHalf: {
    width: "50%",
    padding: 4,
    // margin:"auto"
  },

  // zodiac icons row
  zodiacRow: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 4,
    flexWrap: "wrap",
  },
  zodiacIcon: {
    width: 23,
    height: 23,
    marginRight: 4,
  },

  // sao tot / sao xau
  saoLine: {
    // marginBottom: 3,
  },
  saoLabel: {
    fontWeight: 700,
  },
  saoValue: {
    color: COLOR_BLACK,
    fontWeight: 400,
  },

  // should do / khong nen
  actionRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 6,
  },
  actionIcon: {
    width: 23,
    height: 23,
  },
  actionTextWrap: {
    flexDirection: "column",
    gap: 2,
    flex: 1,
    // paddingHorizontal: 5,
  },
  actionLabel: {
    fontWeight: 700,
    textTransform: "uppercase",
  },
  textAlignJustify: {
    textAlign: "justify",
  },

  // quote
  quoteWrap: {
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 12,
    marginTop: 7,
    height: 32, // 👈 cố định, tương ứng ~57px bạn đo được (chỉnh lại nếu chưa khớp)
  },

  quoteLine: {
    fontSize: 11.4,
    fontStyle: "italic",
    color: COLOR_PRIMARY_TEXT,
    textAlign: "center",
    lineHeight: 1.2,
    paddingHorizontal: 6,
    zIndex: 1,
  },
});

// ========================================================================
// COMPONENT
// ========================================================================
type CalendarContentProps = {
  detailCalendar: any;
  exportMode?: boolean;
  isLastPage?: boolean;
};

export default function CalendarPDFPage({
  detailCalendar,
}: CalendarContentProps): React.ReactElement {
  const title = `Tháng ${detailCalendar?.items[0]?.monthSolar} - Tháng ${mapArrayWithObject(
    [detailCalendar?.items[0]?.thangCan],
    CAN_CHI,
  )} ${mapArrayWithObject([detailCalendar?.items[0]?.thangChi], CAN_CHI)} - Năm ${mapArrayWithObject(
    [detailCalendar?.items[0]?.namCan],
    CAN_CHI,
  )} ${mapArrayWithObject([detailCalendar?.items[0]?.namChi], CAN_CHI)}`;

  // Render zodiac icons (chiHinh / chiHai)
  const renderZodiacIcons = (
    arr: string | string[] | undefined,
    isEvenPage: boolean,
    hasEvents: boolean,
    isSunday: boolean,
  ) => {
    const keys = Array.isArray(arr) ? arr : arr ? [arr] : [];
    if (keys.length === 0) return null;

    const useRedIcon = isSunday || hasEvents;
    const isBlueIcon = isEvenPage;

    return (
      <View style={styles.zodiacRow}>
        {keys.map((key, idx) => {
          const normalizedKey = ZODIAC_IMAGE_KEY_MAP[key] || key;

          const imageKey = useRedIcon
            ? `${normalizedKey}red`
            : isBlueIcon
              ? `${normalizedKey}blue`
              : normalizedKey;
          const src = (IMAGES as any)[imageKey];
          const fallbackSrc = (IMAGES as any)[normalizedKey];

          if (!src && !fallbackSrc) return null;

          return (
            <Image
              key={`${key}-${idx}`}
              src={src || fallbackSrc}
              style={styles.zodiacIcon}
            />
          );
        })}
      </View>
    );
  };

  // Sun icon picker (sunrise / noon / sunset)
  // type: 'sunrise' | 'noon' | 'sunset'
  const getSunIcon = (
    type: "sunrise" | "noon" | "sunset",
    isEvenPage: boolean,
    hasEvents: boolean,
    isSunday: boolean,
  ) => {
    const useRed = isSunday || hasEvents;

    if (type === "sunrise") {
      if (useRed) return IMAGES.sunrisered;
      if (isEvenPage) return IMAGES.sunriseblue;
      return IMAGES.sunrise; // PLACEHOLDER: thay cho SunRiseIcon (đổi màu blue/green theo isEvenPage nếu cần)
    }
    if (type === "noon") {
      if (useRed) return IMAGES.sunlunchred;
      if (isEvenPage) return IMAGES.sunlunchblue;

      return IMAGES.sunlunch; // PLACEHOLDER: thay cho SunLunchIcon
    }
    // sunset
    if (useRed) return IMAGES.sunsetred;
    if (isEvenPage) return IMAGES.sunsetblue;

    return IMAGES.sunset; // PLACEHOLDER: thay cho SunSetIcon
  };

  const isContain2Items = detailCalendar.items.length === 2;

  // const pagesStyles = [
  //   styles.page,
  //   ...(isContain2Items ? [{ flexGrow: 1 }] : [])
  // ]
  // const containerStyles = [
  //   styles.container,
  //   ...(isContain2Items ? [{ flexGrow: 1, position: "relative" as const }] : [])
  // ]
  const pagesStyles = [styles.page];
  const containerStyles = [styles.container];
  // Đặt ngay trước return (...) của component, ví dụ ngay trên dòng
  // const pagesStyles = [styles.page];
  const quoteLines =
    detailCalendar?.folkPoetry?.split(/\n|\|/).filter(Boolean) || [];
  const isMultiLine = quoteLines.length > 1;

  const COLOR_PAGE_BG = "#FFFFFF";
  const COLOR_PAGE_YELLOW = "#FEFAF3";

  return (
    <Page size="A4" style={pagesStyles}>
      <View style={containerStyles}>
        {/* Watermark logo */}
        {/*<Image src={IMAGES.logoPT} style={styles.watermark} />}

        {/* Header */}
        <View>
          <View style={styles.headerRow}>
            <Text style={styles.headerText}>
              {""}{" "}
              {/* Phong thuỷ Đại Nam - Vạn sự niên {detailCalendar?.yearSolar} */}
            </Text>
            <Text style={styles.headerText}>
              {""} {/* Vì cuộc sống An lạc - Thịnh vượng */}
            </Text>
          </View>

          <View style={styles.titleWrap}>
            {/* <Text style={styles.title}>{title}</Text> */}
            <Text style={styles.title}>{""}</Text>
          </View>
        </View>

        {/* Body */}
        <View style={styles.bodyWrap}>
          {detailCalendar?.items?.map((item: any, index: number) => {
            const { day, month, year } = extractDMY(item?.dateSolar);
            const isEvenPage = index % 2 === 1;
            const hasEvents = item?.events?.length > 0;
            const isSunday = item?.weekday === "chu_nhat";
            const accentColor = getAccentColor(isEvenPage, isSunday, hasEvents);
            const boxBorderColor = getBoxBorderColor(
              isEvenPage,
              isSunday,
              hasEvents,
            );

            const estimatedLines =
              item?.events?.reduce((sum: number, event: any) => {
                return sum + Math.ceil(event.name.length / 18);
              }, 0) || 0;

            const solarDaySpacing =
              estimatedLines <= 2
                ? 12
                : estimatedLines <= 4
                  ? 8
                  : estimatedLines <= 6
                    ? 4
                    : 0;

            return (
              <View
                key={index}
                style={[
                  styles.dayBox,
                  {
                    borderColor: boxBorderColor,
                    // marginVertical: index === detailCalendar?.items?.length - 1 ? 6 : 0
                    marginTop:
                      index === detailCalendar?.items?.length - 1 ? 6 : 0,
                    // marginBottom: index === detailCalendar?.items?.length - 1 ? 3 : 0
                  },
                ]}
                wrap={false}
              >
                {/* ===== TOP SECTION: Date card + Info table ===== */}
                <View style={[styles.topSection]}>
                  {/* --- Date card --- */}
                  <View style={styles.dateCardWrap}>
                    <View style={styles.dateCardInner}>
                      <Text
                        style={[
                          styles.dateCardHeader,
                          {
                            backgroundColor: accentColor,
                            borderColor: accentColor,
                          },
                        ]}
                      >
                        {mapArrayWithObject([item?.weekday], WEEKDAY_MAPPING) ||
                          "---"}
                      </Text>

                      <View style={styles.dateCardBody}>
                        <Text
                          style={[
                            styles.solarDay,
                            {
                              color: accentColor,
                              paddingVertical: solarDaySpacing / 2,
                            },
                          ]}
                        >
                          {day || "---"}
                        </Text>

                        <View
                          style={[
                            styles.divider,
                            { borderBottomColor: accentColor },
                          ]}
                        />

                        <Text
                          style={[styles.monthYear, { color: accentColor }]}
                        >
                          {month && year ? `${month}/${year}` : "---"}
                        </Text>

                        <Text style={styles.lunarDate}>
                          {item?.dateLunar || "---"} Âm lịch
                        </Text>

                        {item?.events?.map((event: any) => {
                          const isSpecialDate =
                            Number(day) === 19 &&
                            Number(month) === 8 &&
                            Number(year) === 2027;

                          return (
                            <Text
                              key={event._id}
                              style={[
                                styles.eventText,
                                isSpecialDate
                                  ? { fontSize: 8, lineHeight: 1 }
                                  : {},
                              ]}
                            >
                              {event?.name}
                            </Text>
                          );
                        })}

                        {/* Border bottom */}
                        <View style={styles.cornerBottom} />

                        {/* Border right */}
                        <View style={styles.cornerRight} />

                        {/* Góc chéo */}
                        <View style={styles.cornerCut}>
                          <View style={styles.cornerLine} />
                        </View>
                      </View>
                    </View>
                  </View>

                  {/* --- Info table --- */}
                  <View style={styles.infoTable}>
                    {/* Row 1: Ngày/Giờ | Hành-Tú-Trực */}
                    <View style={styles.infoRow2Col}>
                      <View style={[styles.infoCellHalf, { width: "60%" }]}>
                        <View
                          style={[
                            styles.infoCellHalf,
                            styles.borderRight,
                            { padding: 4 },
                          ]}
                        >
                          <View style={styles.sunInfoCell}>
                            <Text>
                              Ngày:{" "}
                              <Text style={styles.bold}>
                                {mapArrayWithObject(
                                  [
                                    `${item?.ngayCan || "---"}_${item?.ngayChi || "---"}`,
                                  ],
                                  CAN_CHI,
                                ) || "---"}
                              </Text>
                            </Text>
                          </View>
                        </View>
                        <View
                          style={[
                            styles.infoCellHalf,
                            styles.borderRight,
                            { padding: 4 },
                          ]}
                        >
                          <View style={styles.sunInfoCell}>
                            <Text>
                              Giờ:{" "}
                              <Text style={styles.bold}>
                                {mapArrayWithObject(
                                  [`${item?.gio || "---"}`],
                                  CAN_CHI,
                                ) || "---"}
                              </Text>
                            </Text>
                          </View>
                        </View>
                      </View>

                      <View style={[styles.infoCellHalf, { padding: 4 }]}>
                        <View style={styles.sunInfoCell}>
                          <Text>
                            Hành:{" "}
                            <Text style={styles.bold}>
                              {mapArrayWithObject(
                                [item?.nguHanhNgay],
                                NGU_HANH,
                              ) || "---"}
                            </Text>{" "}
                            - Tú:{" "}
                            <Text style={styles.bold}>
                              {mapArrayWithObject([item?.tu], TU) || "---"}
                            </Text>{" "}
                            - Trực:{" "}
                            <Text style={styles.bold}>
                              {mapArrayWithObject([item?.truc], TRUC) || "---"}
                            </Text>
                          </Text>
                        </View>
                      </View>
                    </View>

                    {/* Row 2: Ngày hoàng đạo / Tiết | Bách kỵ */}
                    <View style={[styles.infoRow2Col, styles.borderTop]}>
                      <View style={[styles.infoCellHalf, { width: "60%" }]}>
                        <View
                          style={[
                            styles.infoCellHalf,
                            styles.borderRight,
                            { padding: 4 },
                          ]}
                        >
                          <View style={styles.sunInfoCell}>
                            <Text>
                              Ngày:{" "}
                              <Text style={styles.bold}>
                                {mapArrayWithObject(
                                  [item?.hoangDaoHacDaoType],
                                  NGAY_HOANGDAO_HACDAO_MAPPING,
                                ) || "---"}
                              </Text>
                            </Text>
                          </View>
                        </View>
                        <View
                          style={[
                            styles.infoCellHalf,
                            styles.borderRight,
                            { color: accentColor, padding: 4 },
                          ]}
                        >
                          <View style={styles.sunInfoCell}>
                            <Text style={{ color: accentColor }}>Tiết: </Text>
                            <View style={styles.tietCellInner}>
                              <Text
                                style={[styles.bold, { color: accentColor }]}
                              >
                                {mapArrayWithObject(
                                  [item?.tiet || "---"],
                                  TIET_KHI,
                                ) || "---"}
                              </Text>
                              <Text style={{ color: accentColor }}>
                                {item?.tietKhiTime && `(${item.tietKhiTime})`}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </View>

                      <View style={[styles.infoCellHalf, { padding: 4 }]}>
                        <View style={styles.sunInfoCell}>
                          <Text>
                            Bách kỵ:{" "}
                            {mapSpecialBachKy(item?.bachKy, day, month, year)}
                          </Text>
                        </View>
                      </View>
                    </View>

                    {/* Row 3: Mặt trời mọc / Giữa trưa | Mặt trời lặn */}
                    <View
                      style={[
                        styles.infoRow2Col,
                        styles.borderTop,
                        styles.borderBottom,
                      ]}
                    >
                      <View style={[styles.infoCellHalf, { width: "60%" }]}>
                        <View
                          style={[
                            styles.infoCellHalf,
                            styles.borderRight,
                            { padding: 4 },
                          ]}
                        >
                          <View style={styles.sunInfoCell}>
                            <Image
                              src={getSunIcon(
                                "sunrise",
                                isEvenPage,
                                hasEvents,
                                isSunday,
                              )}
                              style={styles.sunIcon}
                            />
                            <View style={styles.sunInfoTextWrap}>
                              <Text>Mặt trời mọc:</Text>
                              <Text style={styles.bold}>
                                {item?.sun?.sunrise || "---"}
                              </Text>
                            </View>
                          </View>
                        </View>
                        <View
                          style={[
                            styles.infoCellHalf,
                            styles.borderRight,
                            { padding: 4 },
                          ]}
                        >
                          <View style={styles.sunInfoCell}>
                            <Image
                              src={getSunIcon(
                                "noon",
                                isEvenPage,
                                hasEvents,
                                isSunday,
                              )}
                              style={styles.sunIcon}
                            />
                            <View style={styles.sunInfoTextWrap}>
                              <Text>Giữa trưa:</Text>
                              <Text style={styles.bold}>
                                {item?.sun?.noon || "---"}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </View>

                      <View style={[styles.infoCellHalf, { padding: 4 }]}>
                        <View style={styles.sunInfoCell}>
                          <Image
                            src={getSunIcon(
                              "sunset",
                              isEvenPage,
                              hasEvents,
                              isSunday,
                            )}
                            style={styles.sunIcon}
                          />
                          <View style={styles.sunInfoTextWrap}>
                            <Text>Mặt trời lặn:</Text>
                            <Text style={styles.bold}>
                              {item?.sun?.sunset || "---"}
                            </Text>
                          </View>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>

                <View style={[styles.bottomSection]}>
                  <View style={[styles.infoTable, { width: "100%" }]}>
                    {/* ===== ROW: Nhị hợp/Tam hợp/Xung | Hình/Hại ===== */}
                    <View style={styles.row2Col}>
                      {/* Left: Nhị hợp / Tam hợp + Tuổi xung */}
                      <View
                        style={[
                          styles.cell,
                          styles.cellBorderRight,
                          { padding: 0 },
                        ]}
                      >
                        <View style={styles.innerRow2Col}>
                          <View
                            style={[
                              styles.innerCellHalf,
                              styles.borderRight,
                              styles.cellBorderRight,
                            ]}
                          >
                            <Text>
                              <Text
                                style={[styles.bold, { color: accentColor }]}
                              >
                                Nhị hợp:
                              </Text>{" "}
                              {mapArrayWithObject(item?.nhiHop, CAN_CHI) ||
                                "---"}
                            </Text>
                          </View>
                          <View style={styles.innerCellHalf}>
                            <Text>
                              <Text
                                style={[styles.bold, { color: accentColor }]}
                              >
                                Tam hợp:
                              </Text>{" "}
                              {mapArrayWithObject(item?.tamHop, CAN_CHI) ||
                                "---"}
                            </Text>
                          </View>
                        </View>

                        <View style={[styles.borderTop, { padding: 4 }]}>
                          <Text style={{ marginBottom: 2 }}>
                            <Text style={[styles.bold, { color: accentColor }]}>
                              Tuổi xung với ngày:
                            </Text>{" "}
                            {item?.tuoiXungNgay?.map((d: any, idx: number) => (
                              <Text key={idx}>
                                {mapArrayWithObject([d.key], CAN_CHI) || "---"}
                                {idx < item.tuoiXungNgay?.length - 1
                                  ? ", "
                                  : ""}
                              </Text>
                            ))}
                          </Text>

                          <Text>
                            <Text style={[styles.bold, { color: accentColor }]}>
                              Tuổi xung với tháng:
                            </Text>{" "}
                            {item?.tuoiXungThang?.map((d: any, idx: number) => (
                              <Text key={idx}>
                                {mapArrayWithObject([d.key], CAN_CHI) || "---"}
                                {idx < item.tuoiXungThang.length - 1
                                  ? ", "
                                  : ""}
                              </Text>
                            ))}
                          </Text>
                        </View>
                      </View>

                      {/* Right: Hình | Hại */}
                      <View
                        style={[
                          styles.cell,
                          { padding: 0, flexDirection: "row" },
                        ]}
                      >
                        <View
                          style={[
                            styles.innerCellHalf,
                            styles.cellBorderRight,
                            { alignItems: "center" },
                          ]}
                        >
                          <Text>
                            <Text style={styles.bold}>Hình: </Text>
                            {mapArrayWithObject(item?.chiHinh, CAN_CHI) ||
                              "---"}
                          </Text>
                          {renderZodiacIcons(
                            item?.chiHinh,
                            isEvenPage,
                            hasEvents,
                            isSunday,
                          )}
                        </View>
                        <View
                          style={[
                            styles.innerCellHalf,
                            { alignItems: "center" },
                          ]}
                        >
                          <Text>
                            <Text style={styles.bold}>Hại: </Text>
                            {mapArrayWithObject([item?.chiHai], CAN_CHI) ||
                              "---"}
                          </Text>
                          {renderZodiacIcons(
                            item?.chiHai,
                            isEvenPage,
                            hasEvents,
                            isSunday,
                          )}
                        </View>
                      </View>
                    </View>

                    {/* ===== ROW: Sao tốt/xấu | Giờ tốt/xấu ===== */}
                    <View style={[styles.row2Col, styles.borderTop]}>
                      <View style={[styles.cell, styles.cellBorderRight]}>
                        <View style={[styles.saoLine, { marginBottom: 2 }]}>
                          <Text>
                            <Text
                              style={[styles.saoLabel, { color: accentColor }]}
                            >
                              Sao tốt:{" "}
                            </Text>
                            <Text
                              style={[styles.saoValue, styles.textAlignJustify]}
                            >
                              {mapArrayWithObject(item.saoTot, SAO_TOT)}
                            </Text>
                          </Text>
                        </View>
                        <View style={styles.saoLine}>
                          <Text>
                            <Text
                              style={[styles.saoLabel, { color: accentColor }]}
                            >
                              Sao xấu:{" "}
                            </Text>
                            <Text
                              style={[styles.saoValue, styles.textAlignJustify]}
                            >
                              {mapArrayWithObject(item.saoXau, SAO_XAU)}
                            </Text>
                          </Text>
                        </View>
                      </View>

                      <View
                        style={[
                          styles.cell,
                          { padding: 0, flexDirection: "row" },
                        ]}
                      >
                        <View
                          style={[styles.innerCellHalf, styles.cellBorderRight]}
                        >
                          {/* <View style={[styles.innerCellHalf, styles.cellBorderRight, { alignItems: "center" }]}> */}

                          <Text>
                            <Text style={[styles.bold, { color: accentColor }]}>
                              Giờ tốt:
                            </Text>{" "}
                            {mapArrayWithObject(item?.gioTot, CAN_CHI) || "---"}
                          </Text>
                        </View>
                        <View style={styles.innerCellHalf}>
                          <Text>
                            <Text style={[styles.bold, { color: accentColor }]}>
                              Giờ xấu:
                            </Text>{" "}
                            {mapArrayWithObject(item?.gioXau, CAN_CHI) || "---"}
                          </Text>
                        </View>
                      </View>
                    </View>

                    {/* ===== ROW: Điều nên làm | Hạn chế ===== */}
                    <View
                      style={[
                        styles.row2Col,
                        styles.borderTop,
                        { position: "relative", minHeight: ACTION_ROW_HEIGHT },
                      ]}
                    >
                      {/* Border giữa dùng absolute - kéo full height */}
                      <View
                        style={{
                          position: "absolute",
                          left: "49.8%",
                          top: 0,
                          bottom: 0,
                          width: 1,
                          backgroundColor: COLOR_BORDER_DEFAULT,
                          zIndex: 0,
                        }}
                      />
                      {/* <View style={[styles.cell, styles.cellBorderRight]}> */}
                      <View style={[styles.cell, { flex: 1, zIndex: 1 }]}>
                        <View style={styles.actionRow}>
                          <Image
                            src={
                              isSunday || hasEvents
                                ? IMAGES.shoulddored
                                : isEvenPage
                                  ? IMAGES.shoulddoblue
                                  : IMAGES.shouddo
                            }
                            style={styles.actionIcon}
                          />
                          <View style={styles.actionTextWrap}>
                            <Text
                              style={[
                                styles.actionLabel,
                                { color: accentColor },
                              ]}
                            >
                              ĐIỀU NÊN LÀM:
                            </Text>
                            <Text style={[styles.textAlignJustify]}>
                              {capitalizeFirst(
                                mapArrayWithObject(
                                  item.nen,
                                  CONG_VIEC_MAPPING,
                                ) || "",
                              )}
                            </Text>
                          </View>
                        </View>
                      </View>

                      <View style={[styles.cell, { flex: 1, zIndex: 1 }]}>
                        <View style={styles.actionRow}>
                          <Image src={IMAGES.limit} style={styles.actionIcon} />
                          <View style={styles.actionTextWrap}>
                            <Text
                              style={[
                                styles.actionLabel,
                                { color: COLOR_BLACK },
                              ]}
                            >
                              Hạn chế thực hiện các việc:
                            </Text>
                            <Text style={[styles.textAlignJustify]}>
                              {capitalizeFirst(
                                mapArrayWithObject(
                                  item.khongNen,
                                  CONG_VIEC_MAPPING,
                                ) || "",
                              )}
                            </Text>
                          </View>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
            );
          })}

          {/* Folk poetry / quote */}
          <View style={[styles.quoteWrap]}>
            {quoteLines.map((line: string, index: number) => (
              <Text
                key={index}
                style={[
                  styles.quoteLine,
                  isMultiLine ? { lineHeight: 1.15, fontSize: 11.4 } : {},
                ]}
              >
                {line.trim()}
              </Text>
            ))}
          </View>
        </View>
      </View>
    </Page>
  );
}
